import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=35056c30&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"
import style0 from "./preview.vue?vue&type=style&index=0&id=35056c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35056c30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35056c30')) {
      api.createRecord('35056c30', component.options)
    } else {
      api.reload('35056c30', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=35056c30&scoped=true&", function () {
      api.rerender('35056c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview.vue"
export default component.exports